import React, {Component} from 'react';
import './PrimaryButton.css';
import {Link} from 'react-router-dom';

/**
 * Giant call to action button usually used in a side pane on a profile page etc.
 */
class PrimaryLink extends Component {
	render() {
		const {className, onClick, icon = 'person_add', children, to} = this.props;

		return (
			<div className={`PrimaryButton ${className || ''}`}>
				<Link to={to} className="PrimaryButton-button" onClick={onClick}>
					<span className={`icon icon-${icon}`} />
					<span>{children}</span>
				</Link>
			</div>
		);
	}
}

export default PrimaryLink;



// WEBPACK FOOTER //
// ./src/widgets/PrimaryLink.js